export default __webpack_public_path__ + "static/media/superlikeBlack.c03c2aa6.svg";